// @flow
import React from 'react';

import { Text } from 'Components/frameworks/text/Text.jsx';
import { Title } from 'Components/frameworks/title/Title.jsx';

type TourInformationProps = {
  infos: Array<{
    title: string,
    text?: string,
    items?: Array<string>,
  }>,
};

export function TourInformation({ infos }: TourInformationProps) {
  return (
    <div className="flex flex-wrap -m-2">
      {infos.map(({ items, text, title }) => (
        <div className="w-full sm:w-1/2 p-2" key={title}>
          <Title className="mb-3" theme="title-sans-2">
            {title}
          </Title>
          {items && (
            <ul className="reset-list leading-normal text-base text-gray-darker">
              {items.map(item => (
                <li className="list-disc py-1" key={item}>
                  {item}
                </li>
              ))}
            </ul>
          )}
          {text && <Text text={text} />}
        </div>
      ))}
    </div>
  );
}
